<template>
  <div style="background-color: #f4fbff">
    <Header
            :leftArrow="true"
            :leftText="''"
            @leftClick="onClickLeft"></Header>
    <div class="home home-user tel-room-in">
      <div class="tel-room_inner" >
        <div class="preview-area">
          <video
            ref="myCamera"
            class="preview-video"
            :class="{ 'preview-video-hidden': !previewReady }"
            autoplay
            webkit-playsinline
            playsinline
            muted
            id="myCamera"
            v-show="cameraOpen"
          />
          <div class="tel-room_cam cam-off preview-placeholder" v-show="!cameraOpen || !previewReady">
            <p class="cam-off_txt">{{ cameraPreviewMessage }}</p>
          </div>
        </div>
        <div class="tel-room_btn home_menu-area clear">
          <div :class="{ 'tel-room_btn-mic-on': mikeOpen }" class="home_menu-item tel-room_btn-mic" @click="mikeChange">
            <span class="home_menu-txt" v-show="mikeOpen">ON</span>
            <span class="home_menu-txt" v-show="!mikeOpen">OFF</span>
          </div>
          <div :class="{ 'tel-room_btn-video-on': cameraOpen }" class="home_menu-item tel-room_btn-video" @click="cameraChange">
            <span class="home_menu-txt" v-show="cameraOpen">ON</span>
            <span class="home_menu-txt" v-show="!cameraOpen">OFF</span>
          </div>
        </div>
        <van-button class="tel-room_start" @click="doCall()">発信</van-button>
      </div>
    </div>
<!--    <Footer />-->
  </div>
</template>

<script>
  import Footer from "@/components/Footer.vue";
  import Header from "@/components/Header.vue";
  import "vant/es/toast/style";
  import {Toast} from "vant";

  export default {
  data() {
    return {
      chooseItem: {
        id: "",
        name: "",
        type: "",
      },
      mikeOpen: true,
      cameraOpen: false,
      canDoCallFlg:true,
      mediaStream:null,
      mediaRequestPending:false,
      previewReady:false,
      mediaRequestId:0,
    };
  },
  components: {
    Footer,
    Header,
  },
  mounted() {
    this.id = parseInt(this.$route.query.id);
    this.chooseItem.type = this.$route.query.type
    this.chooseItem.id = this.$route.query.chooseItem_id;
    // 20231226 进入页面默认开启摄像头、麦克风
    this.openCameraPreview();
  },
  beforeUnmount(){
    this.stopNavigator();
  },
  methods: {
    onClickLeft() {
      history.back();
    },
    getCameraAccessErrorMessage(error) {
      if (["NotAllowedError", "PermissionDeniedError", "SecurityError"].includes(error?.name)) {
        return "カメラ権限が異常です。";
      }
      if (["NotFoundError", "DevicesNotFoundError", "OverconstrainedError"].includes(error?.name)) {
        return "利用できるカメラが見つかりません。";
      }
      return "カメラを起動できませんでした。";
    },
    getVideoElement() {
      return this.$refs.myCamera || document.getElementById("myCamera");
    },
    wait(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    stopMediaStream(stream) {
      if (!stream || typeof stream.getTracks !== "function") {
        return;
      }
      stream.getTracks().forEach((track) => {
        if (track && typeof track.stop === "function") {
          track.stop();
        }
      });
    },
    resetPreviewVideo() {
      const videoElement = this.getVideoElement();
      if (!videoElement) {
        return;
      }
      try {
        videoElement.pause?.();
      } catch (error) {
        console.log(error);
      }
      videoElement.srcObject = null;
    },
    waitForPreviewFrame(videoElement, requestId) {
      if (videoElement.videoWidth > 0 && videoElement.videoHeight > 0) {
        return Promise.resolve(requestId === this.mediaRequestId);
      }
      return new Promise((resolve) => {
        let done = false;
        const cleanup = () => {
          videoElement.removeEventListener("loadedmetadata", check);
          videoElement.removeEventListener("loadeddata", check);
          videoElement.removeEventListener("playing", check);
        };
        const finish = (result) => {
          if (done) {
            return;
          }
          done = true;
          cleanup();
          resolve(result);
        };
        const check = () => {
          if (requestId !== this.mediaRequestId) {
            finish(false);
            return;
          }
          if (videoElement.videoWidth > 0 && videoElement.videoHeight > 0) {
            finish(true);
          }
        };
        videoElement.addEventListener("loadedmetadata", check);
        videoElement.addEventListener("loadeddata", check);
        videoElement.addEventListener("playing", check);
        setTimeout(() => {
          check();
          if (!done) {
            finish(false);
          }
        }, 1500);
      });
    },
    stopNavigator() {
      this.mediaRequestId++;
      this.stopMediaStream(this.mediaStream);
      this.mediaStream = null;
      this.previewReady = false;
      this.mediaRequestPending = false;
      this.resetPreviewVideo();
    },
    async attachPreviewStream(stream, requestId) {
      const videoElement = this.getVideoElement();
      if (!videoElement) {
        return false;
      }
      videoElement.srcObject = stream;
      videoElement.muted = true;
      videoElement.playsInline = true;
      try {
        const playResult = videoElement.play();
        if (playResult && typeof playResult.then === "function") {
          await playResult;
        }
      } catch (error) {
        console.log("beforeCall preview play failed:", error);
        return false;
      }
      return await this.waitForPreviewFrame(videoElement, requestId);
    },
    async openCameraPreview(showError = true, retry = true) {
      const requestId = ++this.mediaRequestId;
      const previousStream = this.mediaStream;
      let nextStream = null;
      this.cameraOpen = true;
      this.previewReady = false;
      this.mediaRequestPending = true;
      try {
        nextStream = await navigator.mediaDevices.getUserMedia({audio: false, video: true});
        if (requestId !== this.mediaRequestId) {
          this.stopMediaStream(nextStream);
          return false;
        }
        if (!nextStream || nextStream.getVideoTracks().length === 0) {
          throw new Error("media_track_missing");
        }
        this.mediaStream = nextStream;
        const attached = await this.attachPreviewStream(nextStream, requestId);
        if (!attached) {
          throw new Error("preview_play_failed");
        }
        if (previousStream && previousStream !== nextStream) {
          this.stopMediaStream(previousStream);
        }
        this.previewReady = true;
        return true;
      } catch (error) {
        console.log("摄像头视频流获取失败:", error);
        if (nextStream) {
          this.stopMediaStream(nextStream);
        }
        if (
          retry &&
          error?.message === "preview_play_failed" &&
          requestId === this.mediaRequestId &&
          this.cameraOpen
        ) {
          this.mediaStream = null;
          this.previewReady = false;
          this.resetPreviewVideo();
          await this.wait(300);
          if (requestId === this.mediaRequestId && this.cameraOpen) {
            return await this.openCameraPreview(showError, false);
          }
        }
        if (requestId === this.mediaRequestId) {
          this.mediaStream = null;
          this.previewReady = false;
          this.cameraOpen = false;
          this.resetPreviewVideo();
          if (showError) {
            Toast(this.getCameraAccessErrorMessage(error));
          }
        }
        return false;
      } finally {
        if (requestId === this.mediaRequestId) {
          this.mediaRequestPending = false;
        }
      }
    },
    async getUserMedia() {
      return await this.openCameraPreview();
    },
    success(stream) {
      console.log(stream)
      const videoElement = this.getVideoElement();
      if (videoElement) {
        videoElement.srcObject = stream;
      }
    },
    error(error) {
      console.log(`访问用户媒体设备失败${error.name}, ${error.message}`);
    },
    mikeChange() {
      this.mikeOpen = !this.mikeOpen;
    },
    async cameraChange() {
      if (this.cameraOpen) {
        this.cameraOpen = false;
        this.stopNavigator();
        return;
      }
      await this.openCameraPreview();
    },
    doCall() {
      if (this.cameraOpen && this.mediaRequestPending) {
        Toast("カメラを起動しています。しばらくお待ちください。");
        return;
      }
      if (this.cameraOpen && !this.previewReady) {
        Toast("カメラを起動できませんでした。");
        return;
      }
      if(this.canDoCallFlg){
        this.canDoCallFlg = false;
        setTimeout(() => {
          this.canDoCallFlg = true;
        }, 1000);
        this.$emit('callUser',"video",this.chooseItem,this.mikeOpen,this.cameraOpen && this.previewReady);
      }
    },
  },
  watch: {},
  computed: {
    cameraPreviewMessage() {
      if (this.cameraOpen && this.mediaRequestPending) {
        return "カメラを起動しています";
      }
      if (this.cameraOpen && !this.previewReady) {
        return "カメラを起動しています";
      }
      return "カメラがオフになっています";
    },
  },
};
</script>

<style scoped>
.preview-area {
  width: 100%;
  height: 18rem;
  background: #201D1D;
  border-radius: 5px;
  overflow: hidden;
  position: relative;
}

.preview-video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 5px;
  transform: scaleX(-1);
  display: block;
}

.preview-video-hidden {
  visibility: hidden;
}

.preview-placeholder {
  position: absolute;
  inset: 0;
  height: 100% !important;
  border-radius: 5px;
}
</style>
